import './style.css'

export default class Sitemap {
  static selector = ".sitemap";

  constructor(block) {
    this.block = block;
  }

  onResize() {}
  onScroll() {}
}
